// export const KEY_ID = "rzp_test_okRI9Wvg5WUfp6";
// export const SECRET_KEY = "5hiLlLxOn8MaMbkHYuQWMMst";
export const KEY_ID = "rzp_test_7XD7UUKbea9zSO";
export const SECRET_KEY = "YRPWiuBKgS3Fs8ge6ja7raL1";